import "svix-react/style.css";

import { ErrorDialog, Skeleton } from "@codat/orchard-ui";
import { useGetWebhooksDashboard } from "api/portal";
import React from "react";
import { AppPortal } from "svix-react";

import styles from "./SvixEmbed.module.scss";

export const SvixEmbed = () => {
  const [{ data, loading, error }] = useGetWebhooksDashboard();

  if (error) {
    return (
      <ErrorDialog
        statusCode={error?.response?.data.statusCode}
        correlationId={error?.response?.data.correlationId}
      />
    );
  }

  return loading ? (
    <Skeleton height="40rem" />
  ) : (
    <div className={styles.svixWrapper} data-testid="svix-embed">
      <AppPortal style={{ zIndex: 0 }} fullSize url={data?.url} />
    </div>
  );
};
